import { gql } from "../gql";
import "./fragments";

// Queries
export const GET_SHIFT_TEMPLATES_QUERY = gql(`
  query GetShiftTemplatesNew($franchiseId: ID!) {
    getShiftTemplates(franchiseId: $franchiseId) {
      ...ShiftTemplate @unmask
    }
  }
`);

export const GET_SHIFT_TEMPLATE_QUERY = gql(`
  query GetShiftTemplateNew($id: ID!) {
    getShiftTemplate(id: $id) {
      ...ShiftTemplate @unmask
    }
  }
`);

// Mutations
export const CREATE_SHIFT_TEMPLATE_MUTATION = gql(`
  mutation CreateShiftTemplateNew($franchiseId: ID!, $input: CreateTemplateInput!) {
    createShiftTemplate(franchiseId: $franchiseId, input: $input) {
      ...ShiftTemplate @unmask
    }
  }
`);

export const UPDATE_SHIFT_TEMPLATE_MUTATION = gql(`
  mutation UpdateShiftTemplateNew($id: ID!, $input: UpdateTemplateInput!) {
    updateShiftTemplate(id: $id, input: $input) {
      ...ShiftTemplate @unmask
    }
  }
`);

export const DELETE_SHIFT_TEMPLATE_MUTATION = gql(`
  mutation DeleteShiftTemplateNew($id: ID!) {
    deleteShiftTemplate(id: $id)
  }
`);

export const DUPLICATE_SHIFT_TEMPLATE_MUTATION = gql(`
  mutation DuplicateShiftTemplateNew($id: ID!, $newName: String!) {
    duplicateShiftTemplate(id: $id, newName: $newName) {
      ...ShiftTemplate @unmask
    }
  }
`);
